import React from 'react';
import { Form, Input, Select } from 'antd';
import { t } from 'i18next';
import { useMeasurement } from '@/hooks/useMeasurement';
import { CoolingOptions } from '@/store/SiteSurveyForm/constants';
import { platformOptions, getDriveTypeOptions, ManualModeFormProps } from './AdditionalInformationModal.utils';

const ManualModeForm: React.FC<ManualModeFormProps> = ({
  fieldNamePath,
  selectedPlatform,
  onPressureChange,
  onPlatformChange,
}) => {
  const { tunit } = useMeasurement();

  return (
    <div className="form-section">
      <div className="top-row">
        <div className="field-wrapper">
          <Form.Item
            name={[...fieldNamePath, 'platform']}
            label={<span>{t('Platform')}</span>}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            colon={false}
            labelAlign="left"
          >
            <Select placeholder={t('Select')} size="large" options={platformOptions} onChange={onPlatformChange} />
          </Form.Item>
        </div>

        <div className="field-wrapper">
          <Form.Item
            name={[...fieldNamePath, 'driveType']}
            label={<span>{t('Drive Type')}</span>}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            colon={false}
            labelAlign="left"
          >
            <Select
              placeholder={t('Select')}
              size="large"
              options={getDriveTypeOptions(selectedPlatform)}
              disabled={!selectedPlatform}
            />
          </Form.Item>
        </div>

        <div className="field-wrapper">
          <Form.Item
            name={[...fieldNamePath, 'cooling']}
            label={<span>{t('Cooling')}</span>}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            colon={false}
            labelAlign="left"
          >
            <Select
              placeholder={t('Select')}
              size="large"
              options={Object.values(CoolingOptions).map(value => ({
                label: value,
                value: value,
              }))}
            />
          </Form.Item>
        </div>
      </div>

      <div className="bottom-row">
        <div className="field-wrapper">
          <Form.Item name={[...fieldNamePath, 'horsepower']} label={<span>{t('ratedPower')}</span>} layout="vertical">
            <Input placeholder={t('Enter value')} suffix={tunit('ratedHP')} size="large" />
          </Form.Item>
        </div>

        <div className="field-wrapper">
          <Form.Item name={[...fieldNamePath, 'pressure']} label={<span>{t('Pressure')}</span>} layout="vertical">
            <Input
              placeholder={t('Enter value')}
              suffix={<span>{tunit('bar')}</span>}
              size="large"
              onChange={e => onPressureChange(e.target.value, [...fieldNamePath, 'pressure'])}
            />
          </Form.Item>
        </div>
      </div>
    </div>
  );
};

export default ManualModeForm;
